'use strict';

var $    = require('jquery');
var Core = require('../core/core.js');

/**
 * Creates a modal select box item
 *
 * @class
 */

class ModalSelectBox extends Core {

    _defaults() {
        return {
            target: '.js-modal',
            fields: {
                'title': '',
                'options': ''
            }
        };
    }

    constructor(options) {
        super(options);
        
        this.template = `
            <div class="editor__modal__body__selectbox__container">
                <div class="editor__modal__body__selectbox__label"><%- title %></div>
                <select class="editor__modal__body__selectbox js-editor__modal__body__selectbox">
                    <% _.each(options, function(option){ %>
                        <option value='<%- option["value"] %>'><%- option["name"] %></option>
                    <% }); %>
                </select>
            </div>
        `;

        super.render();


        $('.js-editor__modal__body__selectbox', this.$el).on('change', this._optionchanged);
    }

    _optionchanged(e){
        $(e.currentTarget).trigger('Cioui:Modal:selectbox:value', $(e.currentTarget).val());
        $(e.currentTarget).trigger('Cioui:Modal:selectbox:name', $(e.currentTarget).find('option:selected').attr("name"));
    }
}

module.exports = ModalSelectBox;
